import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRefer = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 21,
	height: 20,
	viewBox: "0 0 21 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M13.2041 12.0717C11.8084 10.6652 9.91556 9.875 7.94186 9.875M7.94186 9.875C5.96816 9.875 4.07529 10.6652 2.67967 12.0717C1.28405 13.4782 0.5 15.3859 0.5 17.375M7.94186 9.875C10.5106 9.875 12.593 7.77634 12.593 5.1875C12.593 2.59867 10.5106 0.5 7.94186 0.5C5.37309 0.5 3.2907 2.59867 3.2907 5.1875C3.2907 7.77634 5.37309 9.875 7.94186 9.875ZM20.5 17.375C20.5 14.0938 19.3837 11.2812 16.1279 9.875C16.7395 9.4126 17.4145 8.80539 17.7377 8.10713C18.0609 7.40886 18.2084 6.64106 18.167 5.87169C18.1256 5.10231 17.8967 4.35508 17.5004 3.69612C17.1042 3.03717 16.5529 2.48681 15.8953 2.09375C15.5265 1.8733 14.6395 1.48437 13.5233 1.48437",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M14.7901 13.4435L17.241 13.4435M17.241 13.4435L17.241 15.7908M17.241 13.4435L14.2843 16.7271C13.9129 17.1397 13.3928 17.3877 12.8385 17.4168C12.2841 17.4458 11.7409 17.2535 11.3284 16.8821",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgRefer;
